import React, { SyntheticEvent } from 'react';
import Modal from '@components/Modal/Modal';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

type Props = {
    visible: boolean;
    url: string;
    onClose: () => void;
} & InjectedIntlProps;


class ImageModal extends React.Component<Props> {
    private renderModalButtons = () => {
        return (
            <div className="form-group">
                <div className="col-sm-6">
                    <a className="btn btn-warning pull-left" onClick={(e: SyntheticEvent) => { this.props.onClose(); }}>
                        {this.props.intl.formatMessage({id: 'common.close'})}
                    </a>
                </div>
            </div>
        );
    }

    private renderBody = () => {
        return (
            <div style={{width: '100%', textAlign: 'center'}}>
                <img src={this.props.url} style={{maxWidth: '100%', maxHeight: '300px'}} />
            </div>
        );
    }

    public render() {
        return (
            <Modal
                visible={this.props.visible}
                title={'Kép megjelenítése'}
                onClose={this.props.onClose}
                renderButtons={this.renderModalButtons}
                renderBody={this.renderBody}
            />
        );
    }
}

export default compose(
    injectIntl,
)(ImageModal);



// WEBPACK FOOTER //
// ./src/components/ImageModal.tsx